import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdminRoutingModule } from './admin-routing.module';
import { AdminComponent } from './admin.component';
import { MyCustomMaterialModule } from 'san-common';


@NgModule({
  imports: [
    CommonModule,
    MyCustomMaterialModule,
    AdminRoutingModule,

  ],
  declarations: [AdminComponent]
})
export class AdminModule { }
